export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "legCalculate.worker.ebd7a8a3a1faa454a1f2-legCalculate.worker.worker.js");
}
